module.exports = __webpack_public_path__ + "static/img/top_bg_tv.a611eba.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/top_bg_tv.png
// module id = 1102
// module chunks = 1